/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbSharedMeasurementUnitProvider_searchBrowse$ref = any;
type SbSharedRefineMenuDimensionUnitRadioSelect_searchBrowse$ref = any;
type SbSharedRefineMenuInputRange_searchBrowse$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbSharedRefineMenuInputRangeDimensions_searchBrowse$ref: FragmentReference;
export type SbSharedRefineMenuInputRangeDimensions_searchBrowse = {|
  +$fragmentRefs: SbSharedRefineMenuInputRange_searchBrowse$ref & SbSharedMeasurementUnitProvider_searchBrowse$ref & SbSharedRefineMenuDimensionUnitRadioSelect_searchBrowse$ref,
  +$refType: SbSharedRefineMenuInputRangeDimensions_searchBrowse$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuInputRangeDimensions_searchBrowse",
  "type": "SearchBrowseQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuInputRange_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedMeasurementUnitProvider_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuDimensionUnitRadioSelect_searchBrowse",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'd4e4fc61a6f2ef160087402382fa7f25';
module.exports = node;
